import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Category keys - add or remove categories here
export const CATEGORY_KEYS = [
  "all",
  "design",
  "writing",
  "programming",
  "marketing",
  "videoAnimation",
  "musicAudio",
  "business",
  "data",
  "translation",
  // Add more categories here, e.g.:
  // "photography",
  // "lifestyle",
];

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.title": "Freela",
      "nav.postGig": "Post Gig",
      "nav.myGigs": "My Gigs",
      "nav.messages": "Messages",
      "nav.profile": "Profile",
      "nav.logout": "Logout",
      "nav.login": "Login",
      "nav.signUp": "Sign Up",

      // Hero Section
      "hero.title": "Find the Perfect Freelancer",
      "hero.subtitle": "Connect with talented professionals for your projects",
      "hero.search":
        "Search for services (e.g., logo design, web development...)",

      // Categories
      "category.all": "All",
      "category.design": "Design",
      "category.writing": "Writing",
      "category.programming": "Programming",
      "category.marketing": "Marketing",
      "category.videoAnimation": "Video & Animation",
      "category.musicAudio": "Music & Audio",
      "category.business": "Business",
      "category.data": "Data",
      "category.translation": "Translation",

      // Gigs
      "gigs.all": "All Gigs",
      "gigs.found": "gigs found",
      "gigs.noGigs": "No gigs found",
      "gigs.beFirst": "Be the first to post a gig!",
      "gigs.status.active": "ACTIVE",
      "gigs.status.pending": "PENDING",
      "gigs.status.rejected": "REJECTED",
      "gigs.status.expired": "EXPIRED",
      "gigs.status.inactive": "INACTIVE",
      "gigs.rejected": "Rejected:",
      "gigs.startingAt": "Starting at",

      // Auth
      "auth.welcomeBack": "Welcome Back",
      "auth.createAccount": "Create Account",
      "auth.fullName": "Full Name",
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.login": "Login",
      "auth.signUp": "Sign Up",
      "auth.processing": "Processing...",
      "auth.noAccount": "Don't have an account? ",
      "auth.haveAccount": "Already have an account? ",
      "auth.orGoBack": "Or go back to ",
      "auth.home": "Home",
      "auth.emailExists":
        "This email is already registered. Please login instead or use a different email.",
      "auth.invalidCredentials":
        "Invalid email or password. Please check your credentials and try again.",
      "auth.havingTrouble": "Having trouble logging in? Contact us:",

      // Email Confirmation
      "confirm.checkEmail": "Check Your Email",
      "confirm.sentTo": "We've sent a confirmation email to:",
      "confirm.clickLink":
        "Please click the confirmation link in the email to activate your account.",
      "confirm.didntReceive": "Didn't receive the email?",
      "confirm.checkSpam":
        "Check your spam folder or wait a few minutes and try again.",
      "confirm.alreadyRegistered":
        "If this email is already registered, you won't receive a new confirmation email. Please login instead.",

      // Gig Form
      "gigForm.create": "Create New Gig",
      "gigForm.edit": "Edit Gig",
      "gigForm.title": "Title",
      "gigForm.titlePlaceholder": "e.g., I will design a modern logo",
      "gigForm.description": "Description",
      "gigForm.descriptionPlaceholder": "Describe your service in detail...",
      "gigForm.category": "Category",
      "gigForm.price": "Price (USD)",
      "gigForm.pricePlaceholder": "50.00",
      "gigForm.imageUrl": "Image URL (optional)",
      "gigForm.imageUrlPlaceholder": "https://example.com/image.jpg",
      "gigForm.createButton": "Create Gig",
      "gigForm.updateButton": "Update Gig",
      "gigForm.cancel": "Cancel",
      "gigForm.status": "Visibility Status",
      "gigForm.statusActive": "Active (visible to everyone)",
      "gigForm.statusInactive": "Inactive (hidden from homepage)",
      "gigForm.statusHelp":
        "Set to inactive to temporarily hide this gig from the homepage without deleting it.",
      "gigForm.gigUpdated": "Gig updated successfully!",
      "gigForm.gigDeactivated":
        "Gig deactivated. It's now hidden from the homepage.",
      "gigForm.gigCreatedSuccess":
        "Gig published successfully! It's now live on the homepage.",
      "gigForm.expiryNotice":
        "In order to ensure all gigs are well maintained, a gig will expire automatically in 7 days. You can reactivate it manually.",

      // My Gigs
      "myGigs.title": "My Gigs",
      "myGigs.newGig": "New Gig",
      "myGigs.noGigs": "You haven't created any gigs yet",
      "myGigs.createFirst": "Create your first gig",
      "myGigs.edit": "Edit",
      "myGigs.delete": "Delete",
      "myGigs.deleteConfirm": "Are you sure you want to delete this gig?",
      "myGigs.reactivateConfirm":
        "Reactivate this gig? It will be submitted for review and expire in 7 days once approved.",
      "myGigs.reactivateSuccess": "Gig reactivated and submitted for review!",
      "myGigs.reactivateError": "Failed to reactivate gig. Please try again.",

      // Gig Detail
      "gigDetail.back": "← Back to gigs",
      "gigDetail.aboutGig": "About This Gig",
      "gigDetail.aboutFreelancer": "About the Freelancer",
      "gigDetail.contact": "Contact Freelancer",
      "gigDetail.contactInfo": "Contact Information",
      "gigDetail.emailLabel": "Email:",
      "gigDetail.loginToContact": "Please login to view contact information",
      "gigDetail.startingAt": "Starting at",

      // Messages
      "messages.title": "Messages",
      "messages.noMessages": "No messages yet",
      "messages.selectConversation": "Select a conversation to start messaging",
      "messages.typePlaceholder": "Type a message...",

      // Profile
      "profile.title": "My Profile",
      "profile.edit": "Edit",
      "profile.fullName": "Full Name",
      "profile.bio": "Bio",
      "profile.bioPlaceholder": "Tell us about yourself...",
      "profile.noBio": "No bio yet",
      "profile.saveChanges": "Save Changes",
      "profile.saving": "Saving...",
      "profile.cancel": "Cancel",

      // Gig Card
      "gigCard.edit": "Edit",
      "gigCard.viewDetails": "View Details",
      "gigCard.reactivate": "Reactivate",

      // Footer
      "footer.contactUs": "Contact Us:",
      "footer.rights": "All rights reserved.",

      // Common
      "common.loading": "Loading...",
    },
  },
  zh: {
    translation: {
      // Navigation
      "nav.title": "Freela 接案平台",
      "nav.postGig": "免費發布接案資訊",
      "nav.myGigs": "我的接案資訊",
      "nav.messages": "訊息",
      "nav.profile": "個人檔案",
      "nav.logout": "登出",
      "nav.login": "登入",
      "nav.signUp": "註冊",

      // Hero Section
      "hero.title": "尋找完美的自由工作者",
      "hero.subtitle": "與專業人才連結，完成您的專案",
      "hero.search": "搜尋服務（例如：商標設計、網站開發...）",

      // Categories
      "category.all": "全部",
      "category.design": "設計",
      "category.writing": "寫作",
      "category.programming": "程式開發",
      "category.marketing": "行銷",
      "category.videoAnimation": "影片與動畫",
      "category.musicAudio": "音樂與音效",
      "category.business": "商業",
      "category.data": "數據",
      "category.translation": "翻譯",

      // Gigs
      "gigs.all": "所有接案資訊",
      "gigs.found": "個接案資訊",
      "gigs.noGigs": "找不到接案資訊",
      "gigs.beFirst": "成為第一個發布接案資訊的人！",
      "gigs.status.active": "進行中",
      "gigs.status.pending": "待審核",
      "gigs.status.rejected": "已拒絕",
      "gigs.status.expired": "已過期",
      "gigs.status.inactive": "已停用",
      "gigs.rejected": "拒絕原因：",
      "gigs.startingAt": "起價",

      // Auth
      "auth.welcomeBack": "歡迎回來",
      "auth.createAccount": "建立帳號",
      "auth.fullName": "全名",
      "auth.email": "電子郵件",
      "auth.password": "密碼",
      "auth.login": "登入",
      "auth.signUp": "註冊",
      "auth.processing": "處理中...",
      "auth.noAccount": "還沒有帳號？",
      "auth.haveAccount": "已經有帳號了？",
      "auth.orGoBack": "或返回",
      "auth.home": "首頁",
      "auth.emailExists":
        "此電子郵件已被註冊。請改用登入，或使用其他電子郵件。",
      "auth.invalidCredentials":
        "電子郵件或密碼無效。請檢查您的帳號密碼後重試。",
      "auth.havingTrouble": "登入遇到問題？聯絡我們：",

      // Email Confirmation
      "confirm.checkEmail": "請查看您的電子郵件",
      "confirm.sentTo": "我們已發送確認郵件至：",
      "confirm.clickLink": "請點擊郵件中的確認連結以啟用您的帳號。",
      "confirm.didntReceive": "沒有收到郵件？",
      "confirm.checkSpam": "請檢查您的垃圾郵件資料夾，或等待幾分鐘後再試。",
      "confirm.alreadyRegistered":
        "如果此電子郵件已註冊，您將不會收到新的確認郵件。請改用登入。",
      "confirm.backToSignup": "返回註冊",

      // Gig Form
      "gigForm.create": "建立新接案資訊",
      "gigForm.edit": "編輯接案資訊",
      "gigForm.title": "標題",
      "gigForm.titlePlaceholder": "例如：我會設計現代風格的商標",
      "gigForm.description": "描述",
      "gigForm.descriptionPlaceholder": "詳細描述您的服務...",
      "gigForm.category": "類別",
      "gigForm.price": "價格（美元）",
      "gigForm.pricePlaceholder": "50.00",
      "gigForm.imageUrl": "圖片網址（選填）",
      "gigForm.imageUrlPlaceholder": "https://example.com/image.jpg",
      "gigForm.createButton": "建立接案資訊",
      "gigForm.updateButton": "更新接案資訊",
      "gigForm.cancel": "取消",
      "gigForm.status": "顯示狀態",
      "gigForm.statusActive": "啟用（對所有人可見）",
      "gigForm.statusInactive": "停用（從首頁隱藏）",
      "gigForm.statusHelp": "設定為停用可暫時隱藏此接案資訊，而不需要刪除它。",
      "gigForm.gigUpdated": "接案資訊更新成功！",
      "gigForm.gigDeactivated": "接案資訊已停用。現已從首頁隱藏。",
      "gigForm.gigCreatedSuccess": "接案資訊發布成功！現已在首頁顯示。",
      "gigForm.expiryNotice":
        "為確保所有接案資訊都能維護良好，接案資訊將在 7 天後自動過期。屆時您可以手動重新啟用。",

      // My Gigs
      "myGigs.title": "我的接案資訊",
      "myGigs.newGig": "新接案資訊",
      "myGigs.noGigs": "您還沒有建立任何接案資訊",
      "myGigs.createFirst": "建立您的第一個接案資訊",
      "myGigs.edit": "編輯",
      "myGigs.delete": "刪除",
      "myGigs.deleteConfirm": "您確定要刪除這個接案資訊嗎？",
      "myGigs.reactivateConfirm":
        "重新啟用此接案資訊？它將提交審核，批准後將在 7 天後過期。",
      "myGigs.reactivateSuccess": "接案資訊已重新啟用並提交審核！",
      "myGigs.reactivateError": "重新啟用失敗，請重試。",

      // Gig Detail
      "gigDetail.back": "← 返回接案資訊列表",
      "gigDetail.aboutGig": "關於此接案資訊",
      "gigDetail.aboutFreelancer": "關於接案者",
      "gigDetail.contact": "聯繫接案者",
      "gigDetail.contactInfo": "聯絡資訊",
      "gigDetail.emailLabel": "電子郵件：",
      "gigDetail.loginToContact": "請登入以查看聯絡資訊",
      "gigDetail.startingAt": "起價",

      // Messages
      "messages.title": "訊息",
      "messages.noMessages": "尚無訊息",
      "messages.selectConversation": "選擇一個對話開始聊天",
      "messages.typePlaceholder": "輸入訊息...",

      // Profile
      "profile.title": "我的個人檔案",
      "profile.edit": "編輯",
      "profile.fullName": "全名",
      "profile.bio": "個人簡介",
      "profile.bioPlaceholder": "介紹一下您自己...",
      "profile.noBio": "尚未填寫個人簡介",
      "profile.saveChanges": "儲存變更",
      "profile.saving": "儲存中...",
      "profile.cancel": "取消",

      // Gig Card
      "gigCard.edit": "編輯",
      "gigCard.viewDetails": "查看詳情",
      "gigCard.reactivate": "重新啟用",

      // Footer
      "footer.contactUs": "聯絡我們：",
      "footer.rights": "版權所有",

      // Common
      "common.loading": "載入中...",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
